var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGeorgeLogoIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "314px",
    height: "274px",
    viewBox: "0 0 314 274",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Logo mark") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Colors",
    fill: "#488B55",
    transform: "translate(157, 137) scale(0.67) translate(-157, -137)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.4670545,133.215324 L6.4378751,94.6958087 C-0.876770701,90.4303411 -0.876770701,79.8923605 6.8304443,76.4271273 L156.958975,0.0240153739 C157.021905,-0.00800512464 157.096289,-0.00800512464 157.159219,0.0240153739 L307.391688,76.4271273 C314.549493,80.3067134 314.549493,90.103774 307.811979,94.4231066 L224.213115,137 L307.391688,179.324553 C315.272294,182.804301 315.272294,193.232465 307.391688,197.552092 L157.159219,273.975985 C157.096289,274.008005 157.021905,274.008005 156.958975,273.975985 L6.05271053,197.189887 C-1.29870445,192.272347 -1,183.054295 6.8304443,179.224807 L61.9991378,151.170692 C62.0574094,151.141041 62.3201239,151.141043 62.3783963,151.170692 L129.382164,185.326111 C129.382164,185.326111 157.159219,171.180595 157.159219,171.180595 L82.4670545,133.215324 Z",
    id: "Logo-mark"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeorgeLogoIcon);
export default __webpack_public_path__ + "static/media/george-logo-icon.fe12a353deb1a951840e09970b018467.svg";
export { ForwardRef as ReactComponent };